/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import SEOCopyBlock from '@/components/SEOCopyBlock';
import { buildSEOCopyBlock } from '@/features/common/utils/buildSEOCopyBlock';
import { useSeoMetadata } from '@/features/common/api/getSeoMetadata';
import { useLabels } from '@/hooks/useLabels';
import { usePageType } from '../../../api/getPageType';

const labelMap = {
  boldCopyTitle: 'label_CategoryPage_body_Autozone',
  shopCopyTitle: 'label_CategoryPage_body_Shop',
  withCopyTitle: 'label_CategoryPage_body_With',
};

type Props = {
  descriptionClassName?: string;
};

export const CMSSeoCopy = ({ descriptionClassName }: Props) => {
  const { data: pageTypeData } = usePageType();
  const { boldCopyTitle, shopCopyTitle, withCopyTitle } = useLabels(labelMap);

  const { data: seoMetadataInfo } = useSeoMetadata({
    vehicleMake: pageTypeData?.make ?? undefined,
    vehicleModel: pageTypeData?.model ?? undefined,
    vehicleYear: pageTypeData?.year ?? undefined,
  });

  const seoCopyBlock = buildSEOCopyBlock(
    seoMetadataInfo?.copyBlockOne ?? null,
    seoMetadataInfo?.copyBlockTwo ?? null,
  );

  const catLabel = seoMetadataInfo?.pageHeadingName;

  if (!seoCopyBlock) {
    return null;
  }

  return (
    <SEOCopyBlock
      title={`${shopCopyTitle}${catLabel ? ` ${catLabel} ` : ' '}${withCopyTitle}`}
      boldTitle={boldCopyTitle}
      seoCopyBlock={seoCopyBlock}
      descriptionClassName={descriptionClassName}
    />
  );
};
